<template>
    <div v-show="visible">
        <el-dialog title="将目标学校目录下的子目录和指标复制到当前目录下面" :close-on-click-modal="false"  :visible.sync="visible" :before-close="dialogClose" width="750px">    
            <div class="container">
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-select v-model="queryForm.deptId" placeholder="请选择学校">
                            <el-option
                                v-for="item in depts"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-input v-model="queryForm.title" placeholder="目录指标库"></el-input>
                    </div>
                </div>
                <el-button type="primary" icon="search" @click="getData()">查询</el-button>
                <div style="display: inline-block; height:40px;float: right;">
                    <el-button type="primary"  @click="add()">添加</el-button>
                </div>
                <el-table
                    :data="data"
                    style="width: 100%;margin-bottom: 20px;"
                    row-key="id"
                    v-loading="loading"
                    height="460"
                    :default-expand-all="true"
                    element-loading-background = "rgba(255, 255,255,0.7)"
                    element-loading-text = "数据正在加载中..."
                    border
                    fit highlight-current-row
                    :tree-props="{children: 'children'}"
                    @row-click="handleSelectionChange">
                    <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column>
                    <el-table-column prop="text" label="目录指标库"  :show-overflow-tooltip="true"></el-table-column>
                </el-table>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import http from '../../../../common/http'

    export default {
        data(){
            return{
                loading:false,
                visible:false,
                queryForm:{
                    id:"",
                    deptId:"",
                    title:"",
                },
                submitForm:{
                    id:"",
                    title:""
                },
                data:[],
                depts:[]
            }
        },
        created:function () {
        },
        methods:{
            init(targetDeptId,srcEvaluateId,depts){
                this.visible=true
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields()
                }

                this.depts = depts
                if(this.depts.length > 0){
                    this.queryForm.deptId = this.depts[0].id
                }
                console.log('学校ID', targetDeptId,'源评价ID',srcEvaluateId)
                // 获取数据列表
                this.data=[]
                this.getData()
            },
            indexMethod(index) {
                return (index+1)
            },
            dialogClose(done){
                done()
                this.$reload
            },
            getData(){
                this.loading=true
                let url  = this.evaluateIndicatorsDefineTreeListUrl
                let data = {
                    deptId:this.queryForm.deptId,
                    title:this.queryForm.title,
                    indicatorsType:1,
                };
                // console.log(data);
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.data = res.data.list
                    }else{
                        this.$commonFn.showTip(res.message,3)
                    }
                    this.loading=false
                },(err)=>{
                    console.log(err)
                    this.loading=false
                });
            },
            selectable(row){
                if(row.id == 1){
                    return false
                }else{
                    return true
                }
            },
            handleSelectionChange(row, column, event){
                this.submitForm.id=row.id
                this.submitForm.title=row.text
            },
            // 添加指标值
            add(){
                if(this.$util.isEmpty(this.submitForm.id)){
                    this.$commonFn.showTip("请选择添加的数据",2);
                    return
                }
                this.$parent.setEvaluateAndCatalogData(this.submitForm.id)
                this.visible=false; 
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/mobileset/evaluate/SetEvaluateAndCatalogCopy.vue